var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 94.91053009033203 95.68818664550781"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9274264179835892, 0.3740056673716707, -0.3740056673716707, 0.9274264179835892, -310.67337127363226, -622.6871507422865)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M556,522.4c-2,0-3.6-1.7-3.6-3.7v-62.3c0-2,1.6-3.7,3.6-3.7c2,0,3.6,1.7,3.6,3.7v62.3 C559.6,520.7,558,522.4,556,522.4z",
    style: {
      fill: "#aaa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9274264179835892, 0.3740056673716707, -0.3740056673716707, 0.9274264179835892, -310.67337127363226, -622.6871507422865)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M608.5,522.4c-2,0-3.6-1.7-3.6-3.7v-62.3c0-2,1.6-3.7,3.6-3.7c2,0,3.6,1.7,3.6,3.7v62.3 C612.1,520.7,610.5,522.4,608.5,522.4z",
    style: {
      fill: "#aaa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9274264179835892, 0.3740056673716707, -0.3740056673716707, 0.9274264179835892, -310.67337127363226, -622.6871507422865)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M619.4,481.6c-0.6,2.6-3.3,4.2-5.9,3.6l-21.7-5.4c-2.6-0.7-4.2-3.3-3.5-6l0.9-3.9c0.6-2.6,3.3-4.2,5.9-3.6 l21.7,5.4c2.6,0.6,4.2,3.3,3.5,6L619.4,481.6z",
    style: {
      fill: "#aaa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9274264179835892, 0.3740056673716707, -0.3740056673716707, 0.9274264179835892, -312.91740532541957, -617.1225922436131)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M574.6,496c0.6,2.6-1,5.3-3.6,5.9l-21.7,5.1c-2.6,0.6-5.2-1-5.8-3.7l-0.9-3.9c-0.6-2.6,1-5.3,3.6-5.9 l21.7-5.1c2.6-0.6,5.2,1,5.8,3.7L574.6,496z",
    style: {
      fill: "#aaa"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3930ba1d4917c372085d7428b7df5dc7.svg";
export { ForwardRef as ReactComponent };